import { render, staticRenderFns } from "./League.vue?vue&type=template&id=de2d4514&scoped=true"
import script from "./League.vue?vue&type=script&lang=js"
export * from "./League.vue?vue&type=script&lang=js"
import style0 from "./League.vue?vue&type=style&index=0&id=de2d4514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2d4514",
  null
  
)

export default component.exports